import React from "react";
import { Box, Grid, Typography, Container, Paper } from "@mui/material";
import {
    FaShieldAlt,
    FaCreditCard,
    FaShippingFast,
    FaCheckCircle,
} from "react-icons/fa";

const BenefitsRow = () => {
    const benefits = [
        {
            icon: <FaShieldAlt size={22} />,
            title: "Garantia Premium",
            text: "Até 3 dias úteis de garantia em produtos selecionados.",
        },
        {
            icon: <FaCreditCard size={22} />,
            title: "Pagamento Seguro",
            text: "Parcele em até 12x sem juros.",
        },
        {
            icon: <FaShippingFast size={22} />,
            title: "Entrega Rápida",
            text: "Envio para todo o Brasil com rastreamento.",
        },
        {
            icon: <FaCheckCircle size={22} />,
            title: "Qualidade Certificada",
            text: "Produtos originais.",
        },
    ];

    return (
        <Container maxWidth="xl" sx={{ mt: { xs: 4, md: 8 }, mb: 4 }}>
            <Grid container spacing={{ xs: 1.5, md: 3 }} sx={{ display: "flex", justifyContent: "center" }}>
                {benefits.map((item, i) => (
                    <Grid item xs={12} sm={6} md={3} key={i}>
                        <Paper
                            elevation={0}
                            sx={{
                                height: { xs: "auto", md: 160 },
                                display: "flex",
                                width: { xs: 350, md: 280 },
                                flexDirection: { xs: "row", md: "column" },
                                alignItems: { xs: "center", md: "center" },
                                textAlign: { xs: "left", md: "center" },
                                gap: { xs: 2, md: 0 },
                                px: { xs: 2, md: 3 },
                                py: { xs: 2, md: 3 },
                                borderRadius: "18px",
                                backgroundColor: "#fff",
                                boxShadow: {
                                    xs: "0 2px 8px rgba(0,0,0,0.06)",
                                    md: "0 3px 10px rgba(0,0,0,0.08)",
                                },
                                transition: "0.35s cubic-bezier(.21,.6,.29,1.1)",
                                "&:hover": {
                                    md: {
                                        transform: "translateY(-8px)",
                                        boxShadow: "0 18px 35px rgba(0,0,0,0.18)",
                                    },
                                },
                            }}
                        >
                            {/* ICON */}
                            <Box
                                sx={{
                                    minWidth: 48,
                                    minHeight: 48,
                                    borderRadius: "14px",
                                    backgroundColor: "rgba(30,43,78,0.06)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "var(--azul)",
                                    transition: "0.3s",
                                }}
                            >
                                {item.icon}
                            </Box>

                            {/* TEXT */}
                            <Box>
                                <Typography
                                    sx={{
                                        fontWeight: 800,
                                        fontSize: 15,
                                        color: "var(--cinza)",
                                    }}
                                >
                                    {item.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        mt: 0.4,
                                        color: "#5a5a5a",
                                        fontSize: 13.5,
                                        lineHeight: 1.45,
                                        maxWidth: { md: 220 },
                                    }}
                                >
                                    {item.text}
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default BenefitsRow;